import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConfiguracionCanalState } from '../reducers';

export const selectConfiguracionCanalState = createFeatureSelector<ConfiguracionCanalState>('ConfiguracionCanal');

export const selectConfiguracionCanalLoading = createSelector(
  selectConfiguracionCanalState,
  (state: ConfiguracionCanalState) => state.loading
);

export const selectConfiguracionCanal = createSelector(
  selectConfiguracionCanalState,
  (state: ConfiguracionCanalState) => state?.ConfiguracionCanal
);

export const selectConfiguracionCanalList = createSelector(
  selectConfiguracionCanalState,
  (state: ConfiguracionCanalState) => state.ConfiguracionCanalList
);

export const selectConfiguracionCanalId = createSelector(
  selectConfiguracionCanalState,
  (state: ConfiguracionCanalState) => state.ConfiguracionCanalId
);

export const selectConfiguracionCanalError = createSelector(
  selectConfiguracionCanalState,
  (state: ConfiguracionCanalState) => state.error
);
